import { useAddProductConfirmationDrawerUpdatesMutation } from './RecentlyAddedRegistryItemUpdateDrawer.graphql.generated';
import { useFormik } from 'formik';

type FormValues = {
  markAsMustHave: boolean;
};

type UseUpdateFormArgs = {
  itemId: string;
  onUpdate: () => void;
};

export const useUpdateForm = (args: UseUpdateFormArgs) => {
  const { onUpdate, itemId } = args;
  const [updateProduct, { loading }] = useAddProductConfirmationDrawerUpdatesMutation({
    onCompleted: () => {
      onUpdate();
    },
  });

  const formik = useFormik<FormValues>({
    initialValues: {
      markAsMustHave: false,
    },
    onSubmit: async (values, helpers) => {
      await updateProduct({
        variables: {
          registryItemId: itemId,
          payload: {
            mustHave: values.markAsMustHave,
          },
        },
      });

      // calling `resetForm` will update the `initialValues`
      helpers.resetForm({
        values: {
          markAsMustHave: values.markAsMustHave,
        },
      });
    },
  });

  const hasChanged = formik.values.markAsMustHave !== formik.initialValues.markAsMustHave;

  return {
    formik,
    hasChanged,
    isUpdatingRegistryItem: loading,
  };
};
